export const GRANULOMETRY_RENDERING = 'granulometry/rendering';

export const granulometryRendering = () => <const>{ type: GRANULOMETRY_RENDERING };

export type GranulometryRenderingAction = ReturnType<typeof granulometryRendering>;
